import { render, staticRenderFns } from "./ANoteWidget.vue?vue&type=template&id=1c4b86f2"
import script from "./ANoteWidget.ts?vue&type=script&lang=ts&external"
export * from "./ANoteWidget.ts?vue&type=script&lang=ts&external"
import style0 from "./ANoteWidget.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports